/* =============================================================================
   Formulaire de contact — champ « Précisez la marque ».

   Révélé quand l'option sélectionnée porte data-other (les options commençant
   par « Autre », posées côté Liquid). Le champ devient alors obligatoire, et
   redevient masqué, facultatif et vide dès qu'une marque de la liste est
   choisie — sinon une valeur saisie puis abandonnée partirait quand même.
   ============================================================================= */
(function () {
  var select = document.querySelector('[data-rp-brand-select]');
  var champ = document.querySelector('[data-rp-brand-other]');
  if (!select || !champ) return;

  function majEtat() {
    var option = select.options[select.selectedIndex];
    var autre = !!(option && option.dataset.other);

    champ.hidden = !autre;
    champ.required = autre;
    if (!autre) champ.value = '';

    return autre;
  }

  select.addEventListener('change', function () {
    if (majEtat()) champ.focus();
  });

  /* État initial : le navigateur restaure la sélection au retour arrière ou
     après un envoi en erreur, le champ doit suivre. */
  majEtat();
})();
